import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Injectable()
export class MantenedorConvenioColaboracionService
{
    constructor(private http: HttpClient) { }
   
    muestraListaConvenioColaboracion(buscador:any){
        return this.http.post(`${environment.urlApiPrestamo}/getConvenioColaboracion/filtro`,{
            
               
                numeroPagina: buscador?.currentPage,
                tamanioPagina: buscador?.itemsPerPage
         
        }, 
        { headers: this.armaCabecera() } ).toPromise();
    }

    buscarConvenioColaboracion(rutBuscado: any){
        console.log("rut a buscar", rutBuscado);
        return this.http.get(`${environment.urlApiPrestamo}/getConvenioColaboracion/buscar/porRut/${rutBuscado}`,
        { headers : this.armaCabecera() }).toPromise()

    }

    
    traeCategoriaConvenio(){
        return this.http.get(`${environment.urlApiPrestamo}/getTipoConvenio`,
        { headers:this.armaCabecera() }).toPromise();
    }
  
    traeCantidadCuotas(){
       
        return this.http.get(`${environment.urlApiPrestamo}/getCantidadCuotas`,
        { headers:this.armaCabecera() }).toPromise(); 
    }
    traeDatosProveedor(idProveedor:any){
        {
            return this.http.get(`${environment.urlApiPrestamo}/convenioColaboracion/${idProveedor}`,
                   { headers : this.armaCabecera() }).toPromise();
        } 
    }
    ingresarConvenioColaboracion(idUsuario:any, convenio:any, fechaInicioC:any,fechaFinC:any){
      
       
        return this.http.post(`${environment.urlApiPrestamo}/convenioColaboracion/agregar`,
        {
            rut:convenio.rut.split('-')[0],
            dv:convenio.rut.split('-')[1],
            nombre: convenio.nombre,
            razonSocial: convenio.razonSocial,
            idRegion: convenio.idRegion,            
            idUsuario: idUsuario,
            nombreProveedor: convenio.nombre,
            fechaInicio: fechaInicioC,
            fechaFin: fechaFinC,
            descripcion:convenio.descripcion, 
            estado : convenio.estado,
            archivoAdjunto : convenio.archivo
            
        },
        { headers : this.armaCabecera() }).toPromise();
    }

    traeRegiones()
    {
        return this.http.get(`${environment.urlApiUsuario}/regionesConvenios`, { headers: this.armaCabecera() } ).toPromise()
    }
    
    editarConvenioColaboracion( proveedor: any,fechaInicioC:any,fechaFinC:any){
       
        return this.http.post(`${environment.urlApiPrestamo}/convenioColaboracion/editar`,
        {
            rut:proveedor.rut.split('-')[0],
            dv:proveedor.rut.split('-')[1],
            id:proveedor.id,
            idRegion: proveedor.idRegion,  
            fechaInicio: fechaInicioC,
            fechaFin: fechaFinC,     
            descripcion: proveedor.descripcion,            
            nombre: proveedor.nombre,
            razonSocial: proveedor.razonSocial,
        
            visibleConvenio: proveedor.visibleConvenio
        }
        , { headers: this.armaCabecera() } ).toPromise()
    }
    
    modificarEstado(id: any, estadoAfiliado: any)
    {
        console.log("estadoAfiliado!!! service:",estadoAfiliado)
        return this.http.post(`${environment.urlApiPrestamo}/convenioColaboracion/modificar/estados`,
        { id: id, estado: estadoAfiliado }, { headers : this.armaCabecera() }).toPromise();
    }

    

    armaCabecera()
    {
        return new HttpHeaders({
            'Content-Type':'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        })
    }
    
}
